/**
 * Zero-seat Add-on gate and AI Insights zero-seat warning rules.
 * Pure module: no React, network, formCommon or locale-file imports. Localised
 * values (`yes` / `no`) arrive as arguments.
 */

/**
 * Migration check for an Add-on with zero seats: a Vulcan order, or an explicit
 * No for Vulcan, Copper→Fibre and GoCo. Unanswered values never clear it.
 */
export const isMigrationCleared = ({ vulcan, coperToFibre, goco }, yes, no) =>
  (Boolean(yes) && vulcan === yes) ||
  (Boolean(no) && vulcan === no && coperToFibre === no && goco === no);

/** Callers apply this only when Starter + Office seats being added is 0. */
export const isZeroSeatAddonAllowed = (
  { isAddon, vulcan, coperToFibre, goco },
  yes,
  no
) =>
  Boolean(isAddon) &&
  isMigrationCleared({ vulcan, coperToFibre, goco }, yes, no);

export const isAiInsightsZeroSeatWarningActive = ({
  isAiOrder,
  isAddon,
  totalSeats,
  insightsChecked,
  insightsQuantity
}) =>
  Boolean(isAiOrder) &&
  Boolean(isAddon) &&
  Number(totalSeats) === 0 &&
  Boolean(insightsChecked) &&
  Number(insightsQuantity) > 0;

/** Single-paragraph Contentful rich-text document, as the form's other code-built notes. */
export const buildPlainTextNote = text => ({
  nodeType: 'document',
  data: {},
  content: [
    {
      nodeType: 'paragraph',
      data: {},
      content: [{ nodeType: 'text', value: text, marks: [], data: {} }]
    }
  ]
});
